/**
 * Metadatos del regalo.
 * Ver docs/SPEC.md §5.1.
 */

export const META = {
  titulo: 'Una noche de primavera',
  subtitulo: 'Para mi Jazmín, la flor de mi corazón',
  firma: 'Para mi Jazmín, la flor de mi corazón',
  fecha: '21 · IX · MMXXVI',
} as const;

export type Meta = typeof META;
